export const aciLen = {
    iconName: 'len',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M9.954 3.005c-1.87.09-3.742.967-4.996 2.34-.988 1.082-1.613 2.346-1.85 3.74A7.585 7.585 0 003.1 11.59a7.558 7.558 0 001.297 3.074 7.462 7.462 0 003.407 2.578 7.21 7.21 0 002.732.441 6.517 6.517 0 001.787-.261 7.547 7.547 0 002.734-1.435l.136-.114L17.7 18.38c1.378 1.38 2.54 2.531 2.583 2.558a.543.543 0 00.42.035.53.53 0 00.27-.27c.042-.108.031-.32-.02-.402-.019-.031-1.17-1.194-2.558-2.584l-2.524-2.528.135-.162c.295-.358.626-.854.854-1.283.894-1.681 1.078-3.795.49-5.62a7.337 7.337 0 00-3.242-4.092 7.39 7.39 0 00-4.155-1.028zm-.134.968c-.181.014-.65.087-.852.133a6.657 6.657 0 00-2.312 1.022 6.59 6.59 0 00-1.54 1.551 6.386 6.386 0 00-.823 5.697 6.342 6.342 0 002.397 3.202 6.346 6.346 0 003.858 1.147c.973-.03 1.803-.244 2.7-.699a6.296 6.296 0 002.844-2.904 6.284 6.284 0 00.635-2.948 6.141 6.141 0 00-.665-2.662 5.903 5.903 0 00-1.247-1.724c-1.237-1.205-2.805-1.838-4.516-1.824-.216.001-.432.006-.479.01z',
                fill: 'currentColor',
            },
        },
    },
};
